export const taskTableOption = {
  page: true,
  columnBtn: false,
  refreshBtn: false,
  border: true,
  saveBtn: false,
  updateBtn: false,
  cancelBtn: false,
  viewBtn: false,
  addBtn: false, //新增按钮
  delBtn: false,
  editBtn: false,
  align: 'center',
  menuAlign: 'center',
  searchMenuPosition: 'right', //当前版本不支持
  expand: false, //子表格
  menuWidth: 120,
  searchMenuSpan: 4,
  column: [
    {
      label: '包编号',
      prop: 'packageNo',
      search: true,
      searchSpan: 5,
      searchLabelWidth: 65,
      span: 24,
    },
    {
      label: '当前状态',
      prop: 'status',
      type: 'select',
      searchSpan: 5,
      dicData: [
        {
          label: '已放弃',
          value: -4,
        },
        {
          label: '已取消',
          value: -2,
        },
        {
          label: '超时放弃',
          value: -1,
        },
        {
          label: '待领取',
          value: 1,
        },
        {
          label: '待提交',
          value: 2,
        },
        {
          label: '已提交',
          value: 4,
        },
      ],
      span: 24,
      width: 100,
      search: true,
      slot: true,
    },
    {
      label: '所属类型',
      prop: 'taskType',
      slot: true,
      searchSpan: 4,
      span: 24,
      search: true,
      type: 'select',
      dicData: [
        {
          label: 'PE',
          value: 3,
        },
        {
          label: 'PE审核',
          value: 4,
        },
      ],
      width: 90,
    },
    {
      label: '领取译员',
      prop: 'trId',
      search: true,
      searchPlaceholder: '请输入ID',
      searchSpan: 5,
      span: 24,
    },
    {
      label: '昵称',
      prop: 'nickName',
      span: 24,
    },
    {
      label: '手机号码',
      prop: 'phone',
      span: 24,
      width: 110,
    },
    {
      label: '任务金额',
      prop: 'amount',
      span: 24,
      width: 130,
      slot: true,
    },
    {
      label: '领取时间',
      prop: 'receiveTime',
      slot: true,
      span: 24,
      width: 150,
    },
  ],
};

export const taskDetailOption = {
  card: false,
  refreshBtn: false,
  header: false, //表格头部中间菜单
  page: false,
  menu: false,
  addBtn: false, //新增按钮
  columnBtn: false,
  delBtn: false,
  editBtn: false,
  column: [
    {
      label: '原文',
      prop: 'srcText',
      search: false,
      slot: true,
    },
    {
      label: '译文',
      prop: 'peText',
      search: false,
      slot: true,
    },
    {
      label: '质控结果',
      prop: 'auditResult',
      slot: true,
      search: false,
      width: 150,
    },
    {
      label: '备注',
      prop: 'remark',
      search: false,
      width: 160,
    },
  ],
};
